<template>
  <div class="news-banner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">最新资讯</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NewsBanner',
  }
</script>

<style>
  @media (min-width: 992px) {
    .news-banner {
      width: 100%;
      height: 25.42vw;
      margin-top: 72px;
      overflow-y: hidden;
      background-image: url("../assets/images/newsbanner.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .news-banner .center {
      width: auto !important;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-left: 24.8vw;
    }

    .news-banner .banner-overlay1 {
      padding-top: 9.5vw;
      color: #FFFFFF;
      text-align: left;
    }


    .news-banner .banner-overlay1 .title {
      width: 394px;
      height: 100px;
      font-size: 100px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 100px;
    }

    .news-banner .btn-contactUs {
      margin-top: 41px;
      cursor: pointer;
      color: #ffffff;
      width: 168px;
      height: 58px;
      border-radius: 29px;
      background: linear-gradient(90deg, rgba(39, 46, 63, 0.38) 0%, rgba(33, 36, 51, 0.34) 100%), url('../assets/images/svg/btnborder.svg');
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 400;
    }
  }

  @media (max-width: 992px) {
    .news-banner {
      width: 100vw;
      height: 25.4vw;
      overflow-y: hidden;
      background-image: url("../assets/images/newsbanner.png");
      margin-top: 8vw !important;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .news-banner .center {
      width: auto !important;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-left: 20vw;
    }

    .news-banner .banner-overlay1 {
      padding-top: 12vw;
      color: #FFFFFF;
      text-align: left;
    }


    .news-banner .banner-overlay1 .title {
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 20px;
    }

    .news-banner .btn-contactUs {
      margin-top: 41px;
      cursor: pointer;
      color: #ffffff;
      width: 168px;
      height: 58px;
      border-radius: 29px;
      background: linear-gradient(90deg, rgba(39, 46, 63, 0.38) 0%, rgba(33, 36, 51, 0.34) 100%), url('../assets/images/svg/btnborder.svg');
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 400;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/NewsBanner.vue